import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Ellipses from '../../../../EllipsesControl/EllipsesPresets';

export const BodySpecialAccordionHeaderGroup = ({name, children, className}) => {
	return (
		<StyledBodySpecialAccordionHeaderGroup className={className}>
			<Ellipses.Single>{name}</Ellipses.Single>
			<section className="body-special-accordion-header-group-list">{children}</section>
		</StyledBodySpecialAccordionHeaderGroup>
	);
};

BodySpecialAccordionHeaderGroup.propTypes = {
	name: PropTypes.string,
	className: PropTypes.string
};

BodySpecialAccordionHeaderGroup.defaultProps = {
	className: 'body-special-accordion-header-group'
};

export default BodySpecialAccordionHeaderGroup;

const StyledBodySpecialAccordionHeaderGroup = styled.section`
	border-left: var(--px-1) solid var(--neutrals-200);
	height: var(--px-87);
	line-height: var(--px-22);
	padding: var(--px-10) var(--px-10) var(--px-3) var(--px-20);
	& > .ellipses {
		justify-content: center;
		color: var(--neutrals-700) !important;
	}
	.body-special-accordion-header-group-list {
		display: flex;
		justify-content: center;
		& > div,
		section {
			padding: unset;
		}
	}
	.NotaTooltipSection {
		display: none;
	}
`;
